










import Vue from 'vue'
import ChessBoard from '@/components/ChessBoard.vue'

export default Vue.extend({
  name: 'game',
  components: {
    ChessBoard,
  },
})
